/* eslint-disable */

import React, { useEffect, useState } from 'react';

const Welcome = () => {
    const [visible, setVisible] = useState(true);
    const [fadeStyle, setFadeStyle] = useState({
        opacity: 0,
        transform: 'translateY(20px)',
        transition: 'opacity 1.5s ease, transform 1.5s ease',
    });

    useEffect(() => {
        // Fade in after mount
        const fadeInTimeout = setTimeout(() => {
            setFadeStyle({
                opacity: 1,
                transform: 'translateY(0)',
                transition: 'opacity 1.5s ease, transform 1.3s ease',
            });
        }, 100);

        // Fade out after 3 seconds
        const fadeOutTimeout = setTimeout(() => {
            setFadeStyle({
                opacity: 0,
                transform: 'translateY(-10px)',
                transition: 'opacity 1.5s ease, transform 1.2s ease',
            });
        }, 2500);

        // Remove from view after fade-out completes
        const hideTimeout = setTimeout(() => {
            setVisible(false);
        }, 2800); // Total duration: fade-in (1.5s) + delay (1.6s) + fade-out (1.5s)

        return () => {
            clearTimeout(fadeInTimeout);
            clearTimeout(fadeOutTimeout);
            clearTimeout(hideTimeout);
        };
    }, []);

    if (!visible) return null;

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                // backgroundColor: '#fff',
                zIndex: 9999,
                overflow: 'hidden',
                // ...fadeStyle,
            }}
        >
            <img src="/WelcomePage.gif" alt="Welcome"
                style={{
                    overflow: 'hidden',
                    height: "100vh",
                    width: "92vw",
                }} />
        </div>
    );
};

export default Welcome;
